import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CoursesService } from 'src/app/core/services/courses-service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { UniversityService } from 'src/app/core/services/university.service';
import { CourseProgram } from 'src/app/model/course-program';

@Component({
  selector: 'ms-courses-plan-list',
  templateUrl: './courses-plan-list.component.html',
  styleUrls: ['./courses-plan-list.component.scss']
})
export class CoursesPlanListComponent implements OnInit {
  @Input() courseName!: string;
  course: CourseProgram;
  isLoading: boolean;
  displayedColumns: string[] = ['order', 'courseDescription'];
  subCoursesTable: MatTableDataSource<CourseProgram> = new MatTableDataSource<CourseProgram>();

  constructor(
    private courseService: CoursesService,
    private router: Router,
    private navigateService: NavigateService,
    private universityService: UniversityService
  ) { }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.isLoading = true;

    this.courseService.getExtendedCourseProgram(this.courseName)
    .then((res) => {
      if(res.Result && res.Content){
        this.course = res.Content
        this.subCoursesTable.data = this.course.SubCourses;
      }
      this.isLoading = false
    })
    .catch(err => {
      this.isLoading = false
    })
  }

  async openCourse(selectedCourse: CourseProgram){
    this.isLoading = true;
    try{
      this.course.CourseImage = await this.universityService.getImage(this.course)
      this.navigateService.setLocalStorageData('trainingPlan', JSON.stringify(this.course))
      let extendedCourseRes = await this.courseService.getExtendedCourseProgram(selectedCourse.CourseName)
      if(extendedCourseRes.Result)
        selectedCourse = extendedCourseRes.Content
      selectedCourse.CourseImage = await this.universityService.getImage(selectedCourse)
      this.navigateService.setLocalStorageData('selectedCourse', JSON.stringify(selectedCourse))
      this.router.navigate(['/mago-university/mago-courses/course-detail']);
      this.isLoading = false
    }
    catch (err) {
      this.isLoading = false
    }
  }
}
